module.exports = __webpack_public_path__ + "img/New-Utah-Parkspass-Logo.26009f18.svg";